// getIntercomArticleDataList.js
'use strict';
import { Collection } from 'immutable';
import { createSelector } from '../resource/createCachedSelector.js';

/**
 * Select intercom article data list by article ids
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} articleIds - intercom article ids.
 * @param {bool} [needUnique=true] - should dedupe article ids
 * @return {array} The selected intercom article data list.
 */
const getIntercomArticleDataList = createSelector(
  state => state.get('intercomArticles'),
  (state, language) => language,
  (state, language, articleIds) => articleIds || [],
  (state, language, articleIds, needUnique) => needUnique,
  (articles, language, articleIds, needUnique = true) => {
    let ids = articleIds;
    if (needUnique) {
      ids = [...new Set(articleIds)];
    }
    const result = ids
      .map(articleId => articles.getIn([articleId, language])?.toJS())
      .filter(a => a);
    return result instanceof Collection ? result.toJS() : result;
  }
);

export default getIntercomArticleDataList;
